import { render, staticRenderFns } from "./admin_package_detail.vue?vue&type=template&id=254ed6de&scoped=true&"
import script from "./admin_package_detail.vue?vue&type=script&lang=ts&"
export * from "./admin_package_detail.vue?vue&type=script&lang=ts&"
import style0 from "./admin_package_detail.vue?vue&type=style&index=0&id=254ed6de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254ed6de",
  null
  
)

export default component.exports